let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7gP1W")).then(() => parcelRequire('6FKEB'));